import type { ContentPage, ContentPageParsed, PageContentReference } from '../@types/ContentPage';

const createUrl = (childOf: PageContentReference | null, slug: string) => {
  const parts = [slug];
  if (childOf) {
    parts.unshift(childOf.slug);
  }

  return `/${parts.join('/')}`;
};

class SearchLandingPage {
  static onlyLandingPage = (document: ContentPageParsed | null) =>
    !!document && document?.pageType?.indexOf('Landing page') >= 0;

  static onlyContentPageWithSearch = (document: ContentPageParsed | null) =>
    !!document && document?.pageType.indexOf('Content with search') >= 0;

  static onlyGuaranteePackageLandingPage = (document: ContentPageParsed | null) =>
    !!document && document?.pageType.indexOf('Guarantee package landing page') >= 0;

  static parse = ({
    id,
    bottomContent,
    childOf,
    content,
    contentAlignment,
    content_type,
    createdAt,
    disableNavigation,
    featured,
    featuredMedia,
    pageType,
    relatedSearch,
    searchHits,
    slug,
    shouldHideAds,
    smallFeaturedMedia,
    sortOrder,
    targetAudience,
    theme,
    thumbnail,
    title,
    umbrellaSearchTag,
    updatedAt,
    uspList,
    logo,
  }: ContentPage): ContentPageParsed => {
    const _featuredMedia = featuredMedia ? featuredMedia.file.url : null;
    const _smallFeaturedMedia = smallFeaturedMedia ? smallFeaturedMedia.file.url : null;
    const _thumbnail = thumbnail ? thumbnail.file.url : null;
    const _logo = logo ? logo.file.url : null;

    return {
      url: createUrl(childOf, slug),
      bottomContent,
      childOf,
      content,
      contentAlignment,
      content_type,
      createdAt,
      disableNavigation,
      featured,
      featuredMedia: _featuredMedia,
      id,
      pageType,
      relatedSearch,
      searchHits,
      slug,
      shouldHideAds,
      smallFeaturedMedia: _smallFeaturedMedia,
      sortOrder,
      targetAudience,
      theme,
      thumbnail: _thumbnail,
      title,
      umbrellaSearchTag,
      updatedAt,
      uspList,
      logo: _logo,
    };
  };
}

export default SearchLandingPage;
